import React, { useEffect, useState } from "react";
import "./BlogDetails.css";
import { Col, Container, Row } from "react-bootstrap";
import tractor from "../../assets/images/png/tractor-sale-image-3.png";
import FeatureAdds from "../AllProdutcs/FeatureAdds";
import { useNavigate, useParams } from "react-router-dom";
import { getAllBlogs, getBlogDetails } from "../../services/BlogService";

const BlogDetails = () => {
  const [data, setData] = useState();
  const [recentBlog, setRecentBlog] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  const getBlogs = async () => {
    const response = await getAllBlogs();
    const filteredBlogs = response.data.filter((blog) => blog._id !== id);
    const latestBlogs = filteredBlogs.slice(0, 5);
    setRecentBlog(latestBlogs);
  };

  useEffect(() => {
    getBlogs();
  }, [id]);

  const getDetails = async () => {
    const response = await getBlogDetails(id);
    setData(response.data);
  };

  useEffect(() => {
    getDetails();
  }, [id]);

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const options = {
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };

  return (
    <div className="pb-5 pt-4 bg_clr_light_yellow">
      <Container>
        <Row>
          <Col lg={9}>
            <div>
              <div>
                <img
                  className="w-100 blog-detail-img rounded-3"
                  src={data?.image}
                  alt=""
                />
              </div>
              <h2 className="mb-0 ff_heebo clr_dark_blue fs_7xl mt-2 fw-bold mt-4">
                {data?.title}
              </h2>
              <p className="mb-0 ff_heebo fs_3xsm mt-2">
                {formatDate(data?.createdAt)}
              </p>
              <div>
                {data?.description && (
                  <div
                    className="ff_heebo fs_xsm clr_dark_blue mt-3"
                    dangerouslySetInnerHTML={{ __html: data.description }}
                  />
                )}
              </div>
            </div>
          </Col>

          <Col lg={3}>
            <div className="mb-4 position-sticky top-0">
              <h2 className="ff_heebo fw-bold fs_xl clr_dark_blue">
                Recent <span className="clr_dark_green">Blogs</span>
              </h2>
              <div>
                {recentBlog.map((blog, index) => (
                  <div
                    className="cursor_pointer mt-2"
                    onClick={() => navigate(`/blog-details/${blog._id}`)}
                    key={index}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <img
                        className="recent-blog-small-img rounded-1"
                        src={blog.image}
                        alt=""
                      />
                      <div>
                        <p className="mb-0 ff_heebo clr_dark_blue fs_2xsm mt-2 fw-bold">
                          {blog.title}
                        </p>
                        <p className="mb-0 ff_heebo fs_4xsm">
                          {formatDate(blog.createdAt)}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <FeatureAdds />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BlogDetails;
